/* global VXConfig */
'use strict';

import Constants from '../Constants';
import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import Routes from '../../utils/Routes';
import { doFetch, setCookie } from '../../utils/CommonUtils';
import Flux from '../Flux';
import MessengerGiftStore from './MessengerGiftStore';
import VxqlStore, { doVxqlRequest } from './VxqlStore';
import { GetCards, GetCardsById, OpenCardPack } from './GuestProfile.Queries.js';

const GUEST_SERVICE_URL = VXConfig.guestServiceUrl;
const GUEST_SERVICE_SESSION_ID = VXConfig.vxoneSessionId;
const ChangeEvents = {
	autoRechargeTeaserState: 'autoRechargeTeaserState',
	canOneClickChange: 'canOneClickChange',
	guest: 'guest',
	newsletterSubscribed: 'newsletterSubscribed',
	redeemBonus: 'bonus',
	notificationsSettingsReceived: 'notificationsSettingsReceived',
	geoLocation: 'geoLocation',
	featureFeedbackSent: 'featureFeedbackSent',
	featureFeedbackSet: 'featureFeedbackSet',
	addRelationEvent: 'addRelationEvent',
	pincallVerificationStarted: 'pincallVerificationStarted',
	pincallResultReceived: 'pincallResultReceived',
	conversionChatUpdate: 'conversionChatUpdate',
	freeChatDuration: 'freeChatDuration',
	avsPayRequest: 'avsPayRequest',
	avsBonus: 'avsBonus',
	videoLikeChange: 'videoLikeChange',
	videoDislikeChange: 'videoDislikeChange',
	galleryDislikeChange: 'galleryDislikeChange',
	benefitsCode: 'benefitsCode',
	loyaltyPointsChanged: 'loyaltyPointsChanged',
	fifteenMinutesPreview: 'fifteenMinutesPreview',
	isUberFlowActiveChange: 'isUberFlowActiveChange',
	cardPackChange: 'cardPackChange',
};

let guestData = {};
updateGuestData();

let _freeChatDurations = [];

/**
 *
 * @param {string} query
 * @param {Object} variables
 * @returns {Promise}
 */
function doGuestServiceRequest(query, variables = null) {
	const queryObject = {};
	queryObject.query = query;

	if (variables) {
		queryObject.variables = variables;
	}

	const init = {
		headers: { Authorization: 'Bearer ' + GUEST_SERVICE_SESSION_ID },
	};

	return doFetch(GUEST_SERVICE_URL, queryObject, Constants.HttpMethods.POST, false, init);
}

function updateGuestData(fullUpdate = false) {
	guestData = {
		hasAvs: !!VXConfig.guestHasAvs,
		isLocked: !!VXConfig.guestIsLocked,
		isLoggedIn: !!VXConfig.guestIsLoggedIn,
		isRestricted: !!VXConfig.isGuestRestricted,
		isVip: !!VXConfig.isVip,
		isVXTVAboSubscriber: !!VXConfig.isVXTVAboSubscriber,
		name: VXConfig.guestName,
		email: VXConfig.guestEmail,
		balance: VXConfig.guestBalance,
		balanceFormatted: VXConfig.guestBalanceFormatted,
		autoRechargeAmount: VXConfig.guestAutoRechargeAmount,
		autoRechargeConfig: VXConfig.guestAutoRechargeConfig,
		isPayingCustomer: !!VXConfig.isGuestPayingCustomer,
		isForcePayment: !!VXConfig.isGuestForcePayment,
		oneClickChargeAmounts: VXConfig.guestOneClickChargeAmounts,
		oneClickConfig: VXConfig.guestOneClickConfig,
		isVoicecallActive: !!VXConfig.isVoicecallActive,
		isAnonymousVoicecall: !!VXConfig.isAnonymousVoicecall,
		showDataProtection: !!VXConfig.guestShowDataProtection,
		testGroups: VXConfig.guestTestGroups,
		geoLocation: VXConfig.guestGeoLocation,
		urlPreviewPicture: VXConfig.guestUrlPreviewPicture,
		notificationsSettings: VXConfig.notificationsSettings,
		signupOrigin: VXConfig.guestSignupOrigin,
		boughtGifts: guestData.boughtGifts ? guestData.boughtGifts : {},
		vouchers: guestData.vouchers,
		voucherFromParam: VXConfig.bonusCodeInfo,
		activeFeatureIdsWithFeedback: VXConfig.guestActiveFeatureIdsWithFeedback,
		conversionChatCountdownEnd: VXConfig.conversionChatCountdownEnd,
		conversionChatCandidateCountdownEnd: VXConfig.conversionChatCandidateCountdownEnd,
		pincallVerifications: guestData.pincallVerifications ? guestData.pincallVerifications : {},
		restrictionLevel: VXConfig.guestRestrictionLevel,
		isBlockedForComments: VXConfig.isBlockedForComments,
		avsStatus: VXConfig.guestAvsStatus,
		avsRejectMessage: VXConfig.guestAvsRejectMessage,
		id: VXConfig.guestId,
		loyaltyPoints: VXConfig.guest ? VXConfig.guest.loyaltyPoints : 0,
		preferences: VXConfig.guestPreferences,
		perks: VXConfig.guest ? VXConfig.guest.perks : [],
		frameUrl: VXConfig.guest ? VXConfig.guest.frameUrl : null,
		signupDate: VXConfig.guest ? VXConfig.guest.signupDate : null,
		isUberFlowActive: VXConfig.guest?.isUberFlowActive ?? false,
		uberFlowActorId: null,
	};

	if (typeof window.Flux !== 'undefined' && fullUpdate && guestData.isLoggedIn) {
		Flux.Vxql.getGuestInitData(function (result) {
			if (result.data.guest) {
				guestData.vouchers = result.data.guest.vouchers;
				const perks = [];
				result.data.guest.perks.list.forEach((perk) => {
					perks[perk.type] = perk;
				});

				guestData.perks = perks;
				GuestStore.emitGuestChange();
			}
		});
	}
}

function handleBoughtGiftsForGuest(result) {
	if (result.data) {
		const vxqlBoughtGifts = result.data.guest.boughtMessengerGifts;
		const boughtGifts = {};
		for (let i = 0; i < vxqlBoughtGifts.length; i++) {
			boughtGifts[parseInt(vxqlBoughtGifts[i].gift.id)] = parseInt(vxqlBoughtGifts[i].quantity);
		}
		guestData.boughtGifts = boughtGifts;
		MessengerGiftStore.onBoughtGiftsUpdate();
		MessengerGiftStore.emitGiftMessageChange();
	}
}

/**
 *
 * @param {number} relationTypeId
 * @param {number} objectTypeId
 * @param {number} objectId
 */

/**
 *
 * @param {number} relationTypeId
 * @param {number} objectTypeId
 * @param {number} objectId
 */
function hasGuestRelation(relationTypeId, objectTypeId, objectId) {
	if (!GuestStore.isLoggedIn()) {
		return;
	}

	const payload = {
		subjectTypeId: Flux.Constants.Relations.Subjects.GUEST,
		subjectId: VXConfig.guestId,
		relationTypeId: relationTypeId,
		objectTypeId: objectTypeId,
		objectId: objectId,
	};

	return doFetch(Routes.getRoute(Routes.Names.HAS_RELATION), payload, Constants.HttpMethods.POST, true);
}

function handleFreeChatDurationResult(result, actorId) {
	if (result.data) {
		_freeChatDurations[actorId] = result.data.guest.chatFeatures.freeChatDuration;

		GuestStore.emit(ChangeEvents.freeChatDuration, actorId);
	}
}

const GuestStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: ChangeEvents,

	setVideoLike: function (id) {
		this.emit(this.EVENTS.videoLikeChange, id);
	},
	setVideoDislike: function (id) {
		this.emit(this.EVENTS.videoDislikeChange, id);
	},
	emitGuestChange: function () {
		this.emit(ChangeEvents.guest);
	},
	emitRedeemBonus: function (success, bonus) {
		this.emit(ChangeEvents.redeemBonus, success, bonus);
	},

	emitNewsletterSubscribed: function (success, typeId) {
		this.emit(ChangeEvents.newsletterSubscribed, success, typeId);
	},

	emitAutoRechargeTeaserStateChange(success) {
		this.emit(ChangeEvents.autoRechargeTeaserState, success);
	},

	emitCanOneClickChange() {
		this.emit(ChangeEvents.canOneClickChange);
	},

	emitPincallVerificationStartedEvent: function (verificationId, errorCode, pinLength) {
		this.emit(ChangeEvents.pincallVerificationStarted, verificationId, errorCode, pinLength);
	},

	emitAvsPayRequestEvent: function (avsPayRequestResult) {
		this.emit(ChangeEvents.avsPayRequest, avsPayRequestResult);
	},

	emitAvsBonusEvent: function (avsPayRequestResult) {
		this.emit(ChangeEvents.avsBonus, avsPayRequestResult);
	},

	emitPincallResultReceivedEvent: function (verificationId, errorCode) {
		this.emit(ChangeEvents.pincallResultReceived, verificationId, errorCode);
	},

	emitConversionChatUpdateEvent: function (success) {
		this.emit(ChangeEvents.conversionChatUpdate, success);
	},

	emitFeatureFeedbackSentEvent: function (success, featureId) {
		this.emit(ChangeEvents.featureFeedbackSent, success, featureId);
	},

	emitAddRelationResultEvent: function (success) {
		this.emit(ChangeEvents.addRelationEvent, success);
	},

	emitBenefitsCodeChange: function (code) {
		this.emit(ChangeEvents.benefitsCode, code);
	},
	emitCardPackChange: function () {
		this.emit(ChangeEvents.cardPackChange);
	},
	fifteenMinutesPreviewCountdownChange: function (isDone) {
		this.emit(ChangeEvents.fifteenMinutesPreview, isDone);
	},
	setFeatureFeedback: function (featureId, rating) {
		this.emit(ChangeEvents.featureFeedbackSet, featureId, rating);
	},

	requestGuestBalance: function () {
		doFetch(Routes.getRoute(Routes.Names.GUEST_GET_BALANCE), null, Constants.HttpMethods.GET, false).then((result) => {
			if (result.success && result.data) {
				GuestStore.setBalanceFormatted(result.data.balance, result.data.balanceFormatted, result.data.isPayingCustomer);
			}
		});
	},

	setAutoRechargeTeaserState: function (mode) {
		if (mode && GuestStore.isLoggedIn()) {
			doFetch(Routes.getRoute(Routes.Names.GUEST_AUTO_RECHARGE_TEASER_STATE), { mode: mode }, Constants.HttpMethods.POST, true).then(
				(result) => {
					GuestStore.emitAutoRechargeTeaserStateChange(result.success);
				},
			);
		}
	},

	setBalanceFormatted: function (balance, balanceFormatted, isPayingCustomer = null) {
		guestData.balance = balance;
		guestData.balanceFormatted = balanceFormatted;
		if (isPayingCustomer !== null) {
			guestData.isPayingCustomer = isPayingCustomer;
		}
		GuestStore.emitGuestChange();
	},

	setVouchers: function (vouchers) {
		guestData.vouchers = vouchers;
		GuestStore.emitGuestChange();
	},

	acceptCancellationOffer: function (guestId, platformText, offerActivationFail, offerActivationSuccess) {
		if (guestId) {
			doFetch(
				Routes.getRoute(Routes.Names.GUEST_ACCEPT_CANCELLATION_OFFER),
				{
					guest_id: guestId,
					platform_text: platformText,
				},
				Constants.HttpMethods.POST,
				true,
			).then((result) => {
				if (result.data.accepted_offer) {
					offerActivationSuccess(result.data.accepted_offer_info);
					setCookie(
						Constants.CookieNames.STATUS_BAR_CANCELLATION_OFFER,
						'1',
						0,
						'/',
						'',
						true,
						Flux.Constants.CookieSameSiteAttributes.LAX,
					);
				} else {
					offerActivationFail();
				}
			});
		}
	},

	closeDataProtection: function (accepted) {
		if (GuestStore.isLoggedIn()) {
			doFetch(Routes.getRoute(Routes.Names.GUEST_CLOSE_DATA_PROTECTION), { accepted: accepted }, Constants.HttpMethods.POST, false).then(
				(result) => {
					if (result.success) {
						guestData.showDataProtection = false;
						GuestStore.emitGuestChange();
					}
				},
			);
		}
	},

	closeAgbAndDataProtection: function (accepted) {
		if (GuestStore.isLoggedIn()) {
			doFetch(
				Routes.getRoute(Routes.Names.GUEST_CLOSE_AGB_AND_DATA_PROTECTION),
				{ accepted: accepted },
				Constants.HttpMethods.POST,
				false,
			).then((result) => {
				if (result.success) {
					guestData.showDataProtection = false;
					GuestStore.emitGuestChange();
				}
			});
		}
	},

	getNotificationsSettings: function (onSuccess, onFail) {
		doFetch(Routes.getRoute(Routes.Names.GUEST_NOTIFICATIONS_GET_SETTINGS), {}, Constants.HttpMethods.POST, true)
			.then((result) => {
				if (result.data.notifications_settings) {
					guestData.notificationsSettings = result.data.notifications_settings;
					GuestStore.emit(ChangeEvents.notificationsSettingsReceived);
				}
				if (onSuccess) {
					onSuccess();
				}
			})
			.catch(() => {
				if (onFail) {
					onFail();
				}
			});
	},

	setHasAvs: function (hasAvs) {
		guestData.hasAvs = !!hasAvs;
		GuestStore.emitGuestChange();
	},

	setAvsStatus: function (avsStatus) {
		guestData.avsStatus = avsStatus;
		GuestStore.emitGuestChange();
	},

	setAvsRejectMessage: function (rejectMessage) {
		guestData.avsRejectMessage = rejectMessage;
		GuestStore.emitGuestChange();
	},

	setIsLocked: function (isLocked) {
		guestData.isLocked = !!isLocked;
		GuestStore.emitGuestChange();
	},

	setCanOneClick: function (oneClickConfig, oneClickAmounts, autoRechargeConfig, autoRechargeAmount, isPaying, oneClickChargeAmounts) {
		guestData.autoRechargeAmount = autoRechargeAmount;
		guestData.autoRechargeConfig = autoRechargeConfig;
		guestData.isPayingCustomer = !!isPaying;
		guestData.oneClickChargeAmounts = oneClickChargeAmounts;
		guestData.oneClickConfig = oneClickConfig;
		GuestStore.emitCanOneClickChange();
	},

	setIsVip: function (isVip) {
		guestData.isVip = !!isVip;
		GuestStore.emitGuestChange();
	},

	setIsVoicecallActive: function (isVoicecallActive) {
		guestData.isVoicecallActive = isVoicecallActive;
		GuestStore.emitGuestChange();
	},

	setIsVXTVAboSubscriber: function (isVXTVAboSubscriber) {
		guestData.isVXTVAboSubscriber = !!isVXTVAboSubscriber;
		GuestStore.emitGuestChange();
	},

	subscribeNewsletter: function (typeId, userId = null, emailAddress = null) {
		doFetch(Routes.getRoute(Routes.Names.NEWSLETTER_SUBSCRIBE), { typeId, userId, emailAddress }, Constants.HttpMethods.POST, true)
			.then(function (result) {
				if (result.success && result.data.success) {
					GuestStore.emitNewsletterSubscribed(true, typeId);
				} else {
					throw new Error();
				}
			})
			.catch(function () {
				GuestStore.emitNewsletterSubscribed(false, typeId);
			});
	},

	redeemBonus: function (bonusCode) {
		if (bonusCode) {
			doFetch(Routes.getRoute(Routes.Names.GUEST_REDEEM_BONUS), { code: bonusCode }, Constants.HttpMethods.POST, true).then((result) => {
				GuestStore.emitRedeemBonus(result.data.success, result.data.bonus);
			});
		}
	},

	sendFeatureFeedback: function (featureId, rating, text, url) {
		const handleSendFeatureFeedback = (result) => {
			const success = result.data.guest.sendFeatureFeedback === true;
			if (success) {
				guestData.activeFeatureIdsWithFeedback.push(featureId);
				GuestStore.emitGuestChange();
			} else {
				console.error('Error while sending feature feedback', { result });
			}
			GuestStore.emitFeatureFeedbackSentEvent(success, featureId);
		};
		Flux.Vxql.sendFeatureFeedback(featureId, rating, text, url, handleSendFeatureFeedback);
	},

	startPincallVerification: function (phoneNumber, type, language) {
		const query = `
		mutation StartPincallVerification($phoneNumber: String!, $type: VerificationTypeEnum!, $language: LanguageEnum) {
			pinCall {
				startVerification(phoneNumber: $phoneNumber, type: $type, language: $language) {
					id
					type
					verified
					countryCode
					preCode
					number
					e123
					pinLength
				}
			}
		}`;
		doGuestServiceRequest(query, { phoneNumber, type, language }).then((result) => {
			let errorCode = null;
			if (result.errors) {
				errorCode =
					result.errors.length && result.errors[0].extensions && result.errors[0].extensions.errorCode
						? result.errors[0].extensions.errorCode
						: Flux.Constants.Pincall.ErrorCodes.UNKNOWN;
			}
			let verificationId = null;
			let pinLength = Flux.Constants.Pincall.PinCallLength.MOBILE;
			if (result.data.pinCall.startVerification && !errorCode) {
				verificationId = result.data.pinCall.startVerification.id;
				pinLength = result.data.pinCall.startVerification.pinLength;
				guestData.pincallVerifications[verificationId] = result.data.pinCall.startVerification;
			}
			GuestStore.emitPincallVerificationStartedEvent(verificationId, errorCode, pinLength);
		});
	},

	perpareAvsPayRequest: function () {
		const query = `
		mutation avsPayRequest($forwardUrl: String) {
			avs {
				requestAvs(forwardUrl: $forwardUrl) {
					checkoutLink
				}
			}
		}`;

		let forwardUrl = window.location.href;
		// CamLink special handling
		if (Flux.Guest.isCamlinkActive() && VXConfig.guest.camLink.actorId) {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			urlParams.append('actorId', VXConfig.guest.camLink.actorId);
			urlParams.append('chatType', Flux.Constants.VXMessenger.ChatTypes.LIVECHAT);
			forwardUrl = window.location.pathname + '?' + urlParams.toString();
		} else if (Flux.Guest.getIsUberFlowActive() && Flux.Guest.getUberFlowActorId()) {
			// UberFlow: restart chat after the AVS
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			urlParams.append('actorId', Flux.Guest.getUberFlowActorId());
			urlParams.append('chatType', Flux.Constants.VXMessenger.ChatTypes.LIVECHAT);
			urlParams.append('uberFlow', '1');
			forwardUrl = window.location.pathname + '?' + urlParams.toString();
		}

		doGuestServiceRequest(query, { forwardUrl: forwardUrl }).then((result) => {
			if (result.data.avs.requestAvs) {
				GuestStore.emitAvsPayRequestEvent(result.data.avs.requestAvs);
			}
		});
	},

	isAvsBonusAvailable: function () {
		const query = `
		query IsAvsBonusAvailable {
			avs {
				bonusAvailable
			}
		}`;
		doGuestServiceRequest(query).then((result) => {
			if (result.data.avs) {
				GuestStore.emitAvsBonusEvent(result.data.avs.bonusAvailable);
			}
		});
	},

	verifyPincall: function (id, type, pin) {
		const query = `
		mutation VerifyPincall($id: Int!, $type: VerificationTypeEnum!, $pin: String!) {
			pinCall {
				verifyPin(id: $id, type: $type, pin: $pin) {
					id
					type
					verified
					countryCode
					preCode
					number
					e123
				}
			}
		}`;
		doGuestServiceRequest(query, { id, type, pin }).then((result) => {
			let errorCode = null;
			if (result.errors) {
				errorCode =
					result.errors.length && result.errors[0].extensions && result.errors[0].extensions.errorCode
						? result.errors[0].extensions.errorCode
						: Flux.Constants.Pincall.ErrorCodes.UNKNOWN;
			}
			if (result.data.pinCall.verifyPin && !errorCode) {
				guestData.pincallVerifications[id] = result.data.pinCall.verifyPin;
			}
			GuestStore.emitPincallResultReceivedEvent(id, errorCode);
		});
	},

	setBenefitsCode: function (code) {
		GuestStore.emitBenefitsCodeChange(code);
	},

	setShowDataProtection: function (showDataProtection) {
		guestData.showDataProtection = !!showDataProtection;
		GuestStore.emitGuestChange();
	},

	// Store methods
	init: function () {
		updateGuestData(true);
	},

	updateGuestData: function () {
		updateGuestData();
	},

	updateBoughtGiftsForGuest: function () {
		Flux.Vxql.getBoughtGiftsForGuest(handleBoughtGiftsForGuest);
	},

	getPincallVerificationById: function (id) {
		return guestData.pincallVerifications[id] ? guestData.pincallVerifications[id] : null;
	},

	canAutoRecharge: function () {
		return guestData.isLoggedIn && guestData.autoRechargeConfig !== null;
	},

	canOneClick: function () {
		return guestData.isLoggedIn && guestData.oneClickConfig !== null;
	},

	getBoughtGifts: function () {
		return guestData.boughtGifts;
	},

	getAutoRechargeAmount: function () {
		return guestData.autoRechargeAmount;
	},

	getAutoRechargeConfig: function (kind, hostId) {
		const config = guestData.autoRechargeConfig;
		if (config) {
			config.kind = kind;
			config.hostId = hostId;
		}

		return config;
	},

	getBalance: function () {
		return guestData.balance;
	},

	getVoucherFromParam: function () {
		return guestData.voucherFromParam;
	},

	getBalanceFormatted: function () {
		return guestData.balanceFormatted;
	},

	getNotificationSettings: function () {
		return guestData.notificationsSettings;
	},

	getEmailAddress: function () {
		return guestData.email;
	},

	getId: function () {
		return guestData.id;
	},

	getName: function () {
		return guestData.name;
	},

	getSignupDate: function () {
		return new Date(guestData.signupDate).getFullYear();
	},

	getOneClickAmounts: function () {
		// extract only values from charge amounts
		return guestData.oneClickChargeAmounts.map((item) => item.value);
	},

	getOneClickChargeAmounts: function () {
		return guestData.oneClickChargeAmounts;
	},

	getOneClickConfig: function (kind, hostId) {
		const config = guestData.oneClickConfig;
		if (config) {
			config.kind = kind;
			config.hostId = hostId;
		}

		return config;
	},

	getAVSStatus: function () {
		return guestData.avsStatus;
	},

	getAVSRejectMessage: function () {
		return guestData.avsRejectMessage;
	},

	hasAvs: function () {
		return !!guestData.hasAvs;
	},

	hasTestGroup: function (groupId, group) {
		return guestData.testGroups[groupId] && guestData.testGroups[groupId].value === group;
	},

	isAnonymousVoicecall: function () {
		return !!guestData.isAnonymousVoicecall;
	},

	isDataProtectionShown: function () {
		return !!guestData.showDataProtection;
	},

	isLocked: function () {
		return !!guestData.isLocked;
	},

	isLoggedIn: function () {
		return !!guestData.isLoggedIn;
	},

	isPayingCustomer: function () {
		return guestData.isPayingCustomer;
	},

	isRestricted: function () {
		return guestData.isRestricted;
	},

	isForcePayment: function () {
		return guestData.isForcePayment;
	},

	isBlockedForComments: function () {
		return guestData.isBlockedForComments;
	},

	isVip: function () {
		return !!guestData.isVip;
	},

	isVXTVAboSubscriber: function () {
		return !!guestData.isVXTVAboSubscriber || !!guestData.isVip;
	},

	isVoicecallActive: function () {
		return !!guestData.isVoicecallActive;
	},

	getGeoLocation: function (parsed = false) {
		let geoLocation = guestData.geoLocation;
		if (parsed) {
			geoLocation = [geoLocation.lat, geoLocation.long];
		}
		return geoLocation;
	},

	getGuestUrlPreviewPicture: function () {
		return guestData.urlPreviewPicture;
	},

	getVoucherCountByType: function (type, actorId = null) {
		let count = 0;

		if (!guestData.vouchers) {
			return count;
		}

		for (let i = 0; i < guestData.vouchers.length; i++) {
			const matchType = type === guestData.vouchers[i].type;
			const matchActor = guestData.vouchers[i].actorId === actorId || !guestData.vouchers[i].actorId;

			if (matchType && matchActor) {
				count += guestData.vouchers[i].amount;
			}
		}

		return count;
	},

	getActiveFeatureIdsWithFeedback: function () {
		return guestData.activeFeatureIdsWithFeedback;
	},

	addGuestRelation: function (relationTypeId, objectTypeId, objectId) {
		if (!GuestStore.isLoggedIn()) {
			return;
		}

		const payload = {
			subjectTypeId: Flux.Constants.Relations.Subjects.GUEST,
			subjectId: VXConfig.guestId,
			relationTypeId: relationTypeId,
			objectTypeId: objectTypeId,
			objectId: objectId,
		};

		doFetch(Routes.getRoute(Routes.Names.ADD_RELATION), payload, Constants.HttpMethods.POST, true)
			.then(function (result) {
				if (result.success) {
					GuestStore.emitAddRelationResultEvent(true);
				} else {
					GuestStore.emitAddRelationResultEvent(false);
				}
			})
			.catch(function () {
				GuestStore.emitAddRelationResultEvent(false);
			});
	},

	hasGuestRelation: function (relationTypeId, objectTypeId, objectId) {
		return hasGuestRelation(relationTypeId, objectTypeId, objectId);
	},

	isEligibleForConversionChat: function () {
		return guestData.conversionChatCountdownEnd > 0 && guestData.conversionChatCountdownEnd > Date.now() / 1000;
	},

	isCandidateForConversionChat: function () {
		return guestData.conversionChatCandidateCountdownEnd > 0 && guestData.conversionChatCandidateCountdownEnd > Date.now() / 1000;
	},

	updateConversionChat: function (enable = false) {
		const payload = { action: enable ? 'enable' : 'disable' };
		doFetch(Routes.getRoute(Routes.Names.GUEST_CONVERSION_CHAT), payload, Constants.HttpMethods.POST, true)
			.then((result) => {
				GuestStore.emitConversionChatUpdateEvent(result.data.success);
			})
			.catch(function () {});
	},

	addGuestPreferences: function (data = {}, callback) {
		GuestStore.setGuestPreferences(data);
		doFetch(Routes.getRoute(Routes.Names.GUEST_SAVE_PREFERENCES), { data }, Constants.HttpMethods.POST, true)
			.then((result) => {
				callback(result);
			})
			.catch(function () {});
	},

	getRestrictionLevel: function () {
		return guestData.restrictionLevel;
	},

	/**
	 *
	 * @param {number} actorId
	 */
	loadFreeChatDuration: function (actorId) {
		if (actorId && guestData.isLoggedIn) {
			VxqlStore.loadFreeChatDuration(handleFreeChatDurationResult, actorId);
		}
	},

	getFavoriteModels: function (callback, feedOnly = false, first = 50, withTotals = false) {
		VxqlStore.getFavoriteModels(callback, feedOnly, first, withTotals);
	},

	getFavoriteModelsBlock: function (first, callback, feedOnly = false) {
		VxqlStore.getFavoriteModelsBlock(first, callback, feedOnly);
	},

	getRecommendedModels: function (first, feedOnly, callback) {
		VxqlStore.getRecommendedModels(first, feedOnly, callback);
	},

	getBenefits: function (callback) {
		VxqlStore.getBenefits(callback);
	},

	getMyVisitXSidebarData: function (callback) {
		VxqlStore.getMyVisitXSidebarData(callback);
	},

	getFreeChatDuration: function (actorId) {
		return Object.hasOwn(_freeChatDurations, actorId) ? _freeChatDurations[actorId] : null;
	},

	clearFreeChatDurations: function () {
		_freeChatDurations = [];
		// return null on full-update
		this.emit(ChangeEvents.freeChatDuration, null);
	},

	updateGuestFrameUrl: function (frameUrl) {
		guestData.frameUrl = frameUrl;
		this.emitGuestChange();
	},
	updateLoyaltyPoints: function (points) {
		guestData.loyaltyPoints = points;
		this.emit(ChangeEvents.loyaltyPointsChanged, points);
	},
	getPerks: function () {
		return guestData.perks;
	},
	getFrameUrl: function () {
		return guestData.frameUrl;
	},
	updatePerks: function (perks) {
		guestData.perks = perks;
	},
	isPerkActive: function (perkName) {
		return guestData.perks?.[perkName]?.active ?? false;
	},
	setGuestPreferences: function (preferences) {
		guestData.preferences = preferences;
	},
	getGuestPreferences: function () {
		return guestData.preferences;
	},
	addVote(votingId, votingOptionKey) {
		VxqlStore.guestAddVote(votingId, votingOptionKey);
	},
	deleteVote(votingId, votingOptionKey) {
		VxqlStore.guestDeleteVote(votingId, votingOptionKey);
	},
	isCamlinkActive: function () {
		return VXConfig.guest && VXConfig.guest.camLink && VXConfig.guest.camLink.timerEnd;
	},
	getIsUberFlowActive: function () {
		return guestData.isUberFlowActive;
	},
	setIsUberFlowActive: function (isUberFlowActive, actorId = null) {
		guestData.isUberFlowActive = isUberFlowActive;
		if (isUberFlowActive) {
			guestData.uberFlowActorId = actorId;
		}
		this.emit(ChangeEvents.isUberFlowActiveChange, isUberFlowActive);
	},
	clearUberFlow: function () {
		guestData.isUberFlowActive = false;
		guestData.uberFlowActorId = null;
		this.emit(ChangeEvents.isUberFlowActiveChange, false);
	},
	getUberFlowActorId: function () {
		return guestData.uberFlowActorId;
	},
	getCardsById: function (cardSetId, callback) {
		doVxqlRequest(GetCardsById, { cardSetId }).then((result) => {
			callback(result);
		});
	},
	getCards: function (callback) {
		doVxqlRequest(GetCards, {}).then((result) => {
			callback(result);
		});
	},
	openCardPack: function (guestCardPackId, callback) {
		doVxqlRequest(OpenCardPack, { guestCardPackId }).then((result) => {
			callback(result);
		});
	},
});

export default GuestStore;
